export default __webpack_public_path__ + "static/media/vsnake.abe941ec.png";